import { render, staticRenderFns } from "./PageFields.vue?vue&type=template&id=a4895ec6"
import script from "./PageFields.vue?vue&type=script&lang=js"
export * from "./PageFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports